import { usersApi } from 'src/store/services';
import { AppUser } from 'src/types';
import { useSession } from 'src/hooks';
import { toast } from 'react-toastify';
import { useCallback } from 'react';
import { setPartialAppUser, useAppDispatch } from 'src/store';
import { SAVED_TEXT } from 'src/constants';

const TOAST_ID = 'updateUserDataToast';

export const useUserData = () => {
  const { appUser } = useSession();
  const dispatch = useAppDispatch();

  const [updateUserMutation] = usersApi.useUpdateUserMutation();

  const updateUserData = useCallback(
    async (
      data: Partial<AppUser>,
      showNotificationToast = true,
      notificationText?: string,
    ) => {
      const request = {
        id: appUser.user_id,
        body: {
          ...data,
        },
      };

      dispatch(setPartialAppUser(data));

      await updateUserMutation(request).unwrap();

      if (showNotificationToast) {
        if (!toast.isActive(TOAST_ID)) {
          toast(notificationText || SAVED_TEXT, { toastId: TOAST_ID });
        }
      }
    },
    [updateUserMutation, dispatch, appUser],
  );

  return {
    updateUserData,
  };
};
